/**
 * Shared storage for the referral code captured from a shared ?promo= link.
 *
 * The sessionStorage key is deliberately opaque so customers can't easily guess its purpose.
 * The code is session-scoped (cleared when the tab closes) and consumed at checkout.
 *
 * Validation is intentionally NOT done here — the backend /validate-referral endpoint is the
 * authoritative validator. This module only reads, writes, and clears the value.
 */
export const REFERRAL_CODE_STORAGE_KEY = 'icip_ssx_rt';

/** Stores a referral code (normalised to upper-case). No-op on blank or blocked storage. */
export function saveReferralCode(code: string): void {
  try {
    const value = code?.trim();
    if (value) {
      sessionStorage.setItem(REFERRAL_CODE_STORAGE_KEY, value.toUpperCase());
    }
  } catch {
    /* no-op — non-browser context or blocked storage */
  }
}

/** Returns the stored referral code, or null if none / storage unavailable. */
export function readReferralCode(): string | null {
  try {
    const value = sessionStorage.getItem(REFERRAL_CODE_STORAGE_KEY);
    return value && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
}

/** Removes the stored referral code (e.g. once consumed at checkout). */
export function clearReferralCode(): void {
  try {
    sessionStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
  } catch {
    /* no-op */
  }
}
